module.exports = __webpack_public_path__ + "static/media/order_icon9.2786eebc.png";